import { useState, useEffect } from "react";
import "./QuemSomos.css"
import api from "../services/api";
import ApoieButton from "../components/ApoieButton/ApoieButton";
import PageHero from "../components/PageHero/PageHero";
import heroFallbackUrl from "../assets/images/quem-somos-hero-shaped.png";
import Historia from "../components/QuemSomos/Historia/Historia";
import Timeline from "../components/QuemSomos/Timeline/Timeline";
import Proposito from "../components/QuemSomos/Proposito/Proposito";
import Crencas from "../components/QuemSomos/Crencas/Crencas";
import Pilares from "../components/QuemSomos/Pilares/Pilares";
import Valores from "../components/QuemSomos/Valores/Valores";
import Equipe from "../components/QuemSomos/Equipe/Equipe";
import Faq from "../components/QuemSomos/Faq/Faq";
import { useAdminPage } from "../hooks/useAdminPage";
import FormActions from "../components/Admin/FormActions/FormActions";

const QUEM_SOMOS_TEAM_GROUPS = ["Comitê de Gestão", "Matriz"];

export default function QuemSomos() {
  const [data, setData] = useState(null);
  const [draft, setDraft] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState(false);
  const adminPage = useAdminPage();

  useEffect(() => {
    api
      .get("/config/quem-somos")
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);

  useEffect(() => {
    if (!error) return undefined;

    const timeoutId = window.setTimeout(() => {
      setError(null);
    }, 6000);

    return () => window.clearTimeout(timeoutId);
  }, [error]);

  const handleError = (err) => {
    setError(err);
  };

  const handleEditClick = () => {
    if (!adminPage) return;
    setError(null);
    if (editMode) {
      setError(null);
    } else setDraft(structuredClone(data));
    setEditMode((prev) => !prev);
  };

  const handleSave = () => {
    async function savePage() {
      try {
        setError(null);
        const updatedTimeline = (draft?.timeline || []).filter(
          (item) => !item.markedForDeletion
        );

        for (let i = 0; i < updatedTimeline.length; i++) {
          let item = updatedTimeline[i];

          if (item.newFile) {
            const formData = new FormData();
            formData.append("image", item.newFile);

            const uploadResponse = await api.post("/media/upload", formData);

            if (item.public_id) {
              await api.delete("/media/remove", { data: { public_id: item.public_id } });
            }

            item.image = uploadResponse.data;
            delete item.newFile; // Limpa a referência temporária do arquivo
          }
        }

        const updatedTeam = {
          ...draft?.team,
          members: (draft?.team?.members || []).filter(
            (membro) => !membro.markedForDeletion
          ),
        };

        for (let i = 0; i < updatedTeam?.members?.length; i++) {
          let item = updatedTeam?.members[i];

          if (item.newFile) {
            const formData = new FormData();
            formData.append("image", item.newFile);

            const uploadResponse = await api.post("/media/upload", formData);

            if (item.public_id) {
              await api.delete("/media/remove", { data: { public_id: item.public_id } });
            }

            item.photo = uploadResponse.data;
            delete item.newFile; // Limpa a referência temporária do arquivo
          }
        }

        const payload = {
          ...draft,
          team: updatedTeam,
          timeline: updatedTimeline,
        };

        await api.put("/config/quem-somos", payload);

        setData(payload);
        setEditMode(false);
        setError(null);
      } catch (error) {
        setError(error);
      }
    }

    savePage();
  };


  return (
    <div className="quem-somos-data">
      {adminPage ? (
        <header className="admin-quem-somos__header">
          <h1>EDITAR SEÇÃO</h1>
          <p>Quem Somos</p>
        </header>
      ) : (
        <PageHero
          imageUrl={heroFallbackUrl}
          imageShape="provided"
          title="Quem Somos"
        />)}

      {!adminPage && <ApoieButton />}

      <Historia
        history={editMode ? draft?.history : data?.history}
        editMode={editMode}
        onError={handleError}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            history: { ...prev.history, [field]: value },
          }));
        }}
      />

      <Timeline
        items={editMode ? draft?.timeline : data?.timeline}
        editMode={editMode}
        onError={handleError}
        onChange={(updatedItems) => {
          setDraft((prev) => ({
            ...prev,
            timeline: updatedItems,
          }));
        }}

      />

      <Proposito
        proposito={editMode ? draft?.purpose : data?.purpose}
        visao={editMode ? draft?.vision : data?.vision}
        editMode={editMode}
        onError={handleError}
        onChange={(section, field, value) => {
          setDraft((prev) => ({
            ...prev,
            [section]: { ...prev[section], [field]: value },
          }));
        }}
      />

      <Crencas
        crencas={editMode ? draft?.beliefs : data?.beliefs}
        editMode={editMode}
        onError={handleError}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            beliefs: {
              ...prev?.beliefs,
              [field]: value,
            },
          }));
        }}
      />

      <Pilares
        pilares={editMode ? draft?.pillars : data?.pillars}
        editMode={editMode}
        onError={handleError}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            pillars: {
              ...prev?.pillars,
              [field]: value,
            },
          }));
        }}
      />

      <Valores
        valores={editMode ? draft?.values : data?.values}
        editMode={editMode}
        onError={handleError}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            values: {
              ...prev?.values,
              [field]: value,
            },
          }));
        }}
      />

      <Equipe
        team={editMode ? draft?.team : data?.team}
        groupOptions={QUEM_SOMOS_TEAM_GROUPS}
        editMode={editMode}
        onError={handleError}
        onChange={(updatedItems) => {
          setDraft((prev) => ({
            ...prev,
            team: updatedItems,
          }));
        }}
      />

      <Faq
        faq={editMode ? draft?.faq : data?.faq}
        editMode={editMode}
        onError={handleError}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            faq: { ...prev?.faq, [field]: value },
          }));
        }}
      />
      {adminPage && (<div className="quem-somos-page-admin">
        {error && <span className="error-message">{error.response?.data?.error || error.error ||
          "Ocorreu um erro, verifique os campos"}</span>}
        {editMode ? (
          <FormActions
            onCancel={handleEditClick}
            onSave={handleSave}
          />
        ) : (
          <FormActions editing={false} onEdit={handleEditClick} />
        )}
      </div>)}
    </div>
  );
}
